<template>
  <div class="notifications-header">
    <div class="header-icon">
      <img :src="notificationsIcon" alt="notificaciones" />
    </div>
    <h2 class="header-title">{{ $t('notifications.title') }}</h2>
  </div>
</template>

<script>
// Icons
import notificationsIcon from '@/static/icons/notificaciones.svg';

export default {
  name: 'NotificationsHeader',
  computed: {
    notificationsIcon: () => notificationsIcon,
  },
};
</script>
